import {
  humanizeSolutionType,
  SolutionType,
} from '../../../constants/user-info/solutionType';

export const getHumanizeSolutionType = (solutionType: SolutionType): string => {
  return humanizeSolutionType[solutionType] ?? solutionType;
};
